import React from "react";
import WaveSurferContext from "../contexts/WaveSurferContext";
import useWavesurfer from "../hooks/useWavesurfer";
// TODO: research on ref usage
function WaveSurfer({ children, plugins = [], onMount, ...props }) {
    const wavesurfer = useWavesurfer({
        plugins,
        onMount,
        ...props,
    });
    return (React.createElement(WaveSurferContext.Provider, { value: wavesurfer }, children));
}
export default WaveSurfer;
//# sourceMappingURL=WaveSurfer.js.map